<template lang="pug">
    tr(v-if="validCampaignCustomerActive")
        td.no-wrap.xs-width.red--text
            div(v-if="validUnrespondedToTimeInSeconds")
                strong {{ (campaignCustomerActive.conversation_group.unresponded_to_time_in_seconds || 0) | secondsToFullWords }}
            div(v-else) N/a
        td.no-wrap.sm-width
            v-tooltip(top)
                template(v-slot:activator='{ on, attrs }')
                    span(v-bind="attrs" v-on="on" role="text")
                        | {{ userName | str_limit(25) }}
                span
                    | {{ userName }}
        td.no-wrap.sm-width
            div(v-if="validCustomer")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            | {{ customerName | str_limit(25) }}
                    span
                        | {{ customerName }}
            div(v-else) N/a

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            customerName() {
                if (!this.validCustomer) {
                    return null;
                }

                const names = [];

                // First name
                if (this.campaignCustomerActive.customer.first_name_id > 0 && this.campaignCustomerActive.customer.first_name?.length > 0) {
                    names.push(this.campaignCustomerActive.customer.first_name);
                }

                // Middle name
                if (this.campaignCustomerActive.customer.middle_name_id > 0 && this.campaignCustomerActive.customer.middle_name?.length > 0) {
                    names.push(this.campaignCustomerActive.customer.middle_name);
                }

                // Last name
                if (this.campaignCustomerActive.customer.last_name_id > 0 && this.campaignCustomerActive.customer.last_name?.length > 0) {
                    names.push(this.campaignCustomerActive.customer.last_name);
                }

                return names.join(" ").trim();
            },
            rowColor() {

                // Init
                const seconds = (this.campaignCustomerActive?.conversation_group?.unresponded_to_time_in_seconds || 0);

                // alert error
                if (seconds >= 600) {
                    return "var(--error)";
                }

                // alert warning
                if (seconds > 0) {
                    return "var(--orange)";
                }

                // alert success
                return "var(--success)";
            },
            statusClass() {
                let className = "";
                switch(this.campaignCustomerActive?.status) {
                case "assigned":
                    className = "info--text";
                    break;
                case "in_progress":
                    className = "warning--text";
                    break;
                }

                return className;
            },
            userName() {
                if (!this.validCampaignCustomerActive) {
                    return null;
                }

                const names = [];

                // First name
                if (this.campaignCustomerActive.user_first_name?.length > 0) {
                    names.push(this.campaignCustomerActive.user_first_name);
                }

                // Last name
                if (this.campaignCustomerActive.user_last_name?.length > 0) {
                    names.push(this.campaignCustomerActive.user_last_name);
                }

                return names.join(" ").trim();
            },
            validCampaignCustomerActive() {
                return this.campaignCustomerActive?.campaign_customer_active_id > 0;
            },
            validConversationGroup() {
                return this.campaignCustomerActive?.conversation_group?.conversation_group_id > 0;
            },
            validCustomer() {
                return this.campaignCustomerActive?.customer?.customer_id > 0;
            },
            validUnrespondedToTimeInSeconds() {
                return this.validConversationGroup && this.campaignCustomerActive?.conversation_group?.unresponded_to_time_in_seconds !== null && this.campaignCustomerActive?.conversation_group?.unresponded_to_time_in_seconds !== undefined;
            },
        },
        components: {
        },
        props: {
            campaignCustomerActive: Object,
        },
    });
</script>

<style lang="scss" scoped>
</style>